import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useMutableRef } from '@carnica/utils/hooks';
import { useEffect, useMemo, useState } from 'react';
export var useBannerControls = function useBannerControls(_ref) {
  var withControls = _ref.withControls,
    swiperNodeRef = _ref.swiperNodeRef,
    swiper = _ref.swiper,
    _ref$controlsResponse = _ref.controlsResponseArea,
    controlsResponseArea = _ref$controlsResponse === void 0 ? 240 : _ref$controlsResponse;
  var _useState = useState([false, false]),
    _useState2 = _slicedToArray(_useState, 2),
    _useState2$ = _slicedToArray(_useState2[0], 2),
    showPrevControl = _useState2$[0],
    showNextControl = _useState2$[1],
    setControls = _useState2[1];
  var controlsResponseAreaRef = useMutableRef(controlsResponseArea);
  var analyzeMousePosition = function analyzeMousePosition(e) {
    var _swiper$current, _swiper$current2, _swiper$current3;
    if (!swiperNodeRef.current) {
      return;
    }
    var activeSlide = (((_swiper$current = swiper.current) === null || _swiper$current === void 0 ? void 0 : _swiper$current.realIndex) || 0) + 1;
    var slidesCount = ((_swiper$current2 = swiper.current) === null || _swiper$current2 === void 0 ? void 0 : _swiper$current2.slides.length) || 1;
    var loop = ((_swiper$current3 = swiper.current) === null || _swiper$current3 === void 0 ? void 0 : _swiper$current3.params.loop) || false;
    var componentOffset = swiperNodeRef.current.getBoundingClientRect().x;
    var leftVisible = e.pageX - componentOffset < controlsResponseAreaRef.current;
    var rightVisible = swiperNodeRef.current.offsetWidth + componentOffset - e.pageX < controlsResponseAreaRef.current;
    setControls([leftVisible && (loop || activeSlide !== 1), rightVisible && (loop || activeSlide !== slidesCount)]);
  };
  useEffect(function () {
    if (!withControls) {
      setControls([false, false]);
    } else {
      var _swiperNodeRef$curren, _swiperNodeRef$curren2;
      (_swiperNodeRef$curren = swiperNodeRef.current) === null || _swiperNodeRef$curren === void 0 ? void 0 : _swiperNodeRef$curren.addEventListener('mousemove', analyzeMousePosition);
      (_swiperNodeRef$curren2 = swiperNodeRef.current) === null || _swiperNodeRef$curren2 === void 0 ? void 0 : _swiperNodeRef$curren2.addEventListener('mouseleave', function () {
        return setControls([false, false]);
      });
    }
    return function () {
      if (withControls) {
        var _swiperNodeRef$curren3, _swiperNodeRef$curren4;
        (_swiperNodeRef$curren3 = swiperNodeRef.current) === null || _swiperNodeRef$curren3 === void 0 ? void 0 : _swiperNodeRef$curren3.removeEventListener('mousemove', analyzeMousePosition);
        (_swiperNodeRef$curren4 = swiperNodeRef.current) === null || _swiperNodeRef$curren4 === void 0 ? void 0 : _swiperNodeRef$curren4.removeEventListener('mouseleave', function () {
          return setControls([false, false]);
        });
      }
    };
  }, [withControls]);
  return useMemo(function () {
    return {
      showPrevControl: showPrevControl,
      showNextControl: showNextControl
    };
  }, [showNextControl, showPrevControl]);
};